/**
 * Runtime config constants. Small enough that a single module beats
 * per-feature configs.
 */

/**
 * Mailcoach subscribe endpoint for the waitlist. Form POSTs `email`
 * (and optional `tags`) directly here; Mailcoach handles confirmation.
 *
 * Set to an empty string to hide the waitlist form entirely.
 */
export const MAILCOACH_SUBSCRIBE_URL =
  "https://dawhub.mailcoach.app/subscribe/398aa32e-d28b-492d-bd44-cb0bed839190";
